import { ShaderInputs } from "./ShaderInputs";
import { BasePreprocessingShader } from "./BasePreprocessingShader";
import { engine } from "../KotlinLib";

export class DiffuseColoredLmShader extends BasePreprocessingShader implements ShaderInputs {
    public attributes?: number[];
    public typedAttributes?: { [key: number]: number };
    public uniforms?: WebGLUniformLocation[];

    /** @inheritdoc */
    fillCode() {
        this.vertexShaderCode = `uniform mat4 view_proj_matrix;
            attribute vec4 rm_Vertex;
            attribute vec2 rm_TexCoord0;
            attribute vec2 rm_TexCoord1;

            varying vec4 vTexCoord;

            void main() {
              gl_Position = view_proj_matrix * rm_Vertex;
              vTexCoord = vec4(rm_TexCoord0, rm_TexCoord1);
            }`;

        this.fragmentShaderCode = `precision mediump float;
            varying vec4 vTexCoord;
            uniform sampler2D sTexture;
            uniform sampler2D sLM;
            uniform vec4 color;

            void main() {
                vec2 texCoord0 = vTexCoord.xy;
                vec2 texCoord1 = vTexCoord.zw;
                vec4 diffuse = texture2D(sTexture, texCoord0);
                vec4 lm = texture2D(sLM, texCoord1);
                gl_FragColor = diffuse * color * lm.r;
                gl_FragColor.a = diffuse.a;
            }`;
    }

    /** @inheritdoc */
    fillUniformsAttributes() {
        const rm_Vertex = this.getAttrib("rm_Vertex");
        const rm_TexCoord0 = this.getAttrib("rm_TexCoord0");
        const rm_TexCoord1 = this.getAttrib("rm_TexCoord1");

        const view_proj_matrix = this.getUniform("view_proj_matrix");
        const sTexture = this.getUniform("sTexture");
        const sLM = this.getUniform("sLM");
        const color = this.getUniform("color");

        this.attributes = [rm_Vertex, rm_TexCoord0, rm_TexCoord1];
        this.typedAttributes = {
            [engine.AttributeType.VERTEX.ordinal]: rm_Vertex,
            [engine.AttributeType.UV0.ordinal]: rm_TexCoord0,
            [engine.AttributeType.UV1.ordinal]: rm_TexCoord1,
        };
        this.uniforms = [
            view_proj_matrix, // 0
            sTexture, // 1
            sLM, // 2
            color // 3
        ];
    }
}
